export const addClassWithDelay = (stringSelector, className) => {
  setTimeout(() => {
    const element = document.querySelector(stringSelector);
    if (element) {
      element.classList.add(className);
    }
  }, 15000);
};
